module.exports = __webpack_public_path__ + "a1de0237.svg";